import * as React from 'react';
import { useHistory } from 'react-router-dom';
import { isAuthenticate } from '../../../../utils/helpers/helpers';
import { routes } from '../../../../utils/constants/constant';
import './MobileHome.scss';
import MobilePartner from './MobilePartner/MobilePartner';
import MobileStartNow from './MobileStartNow/MobileStartNow';
import MobileWhyChoice from './MobileWhyChoice/MobileWhyChoice';

const MobileHome = (props) => {
  const history = useHistory();
  if (isAuthenticate()) {
    history.push(routes.DASHBOARD);
    return null;
  }
  return (
    <div className='mobile-home'>
      <div className='banner'>
        <div className='grow_offer'>
          <span>
            Tăng thu nhập cùng <span style={{ color: '#FF3366' }}> Mytour</span>
          </span>

          <span>
            Tích lũy Hoa hồng
            <br /> ngay hôm nay!
          </span>
          <span className='description'>
            Sản phẩm mang đến mức giá cạnh tranh, tỷ lệ chuyển đổi cao và đem về
            các khoản hoa hồng hấp dẫn.
          </span>
        </div>
      </div>
      <div className='register' onClick={() => history.push(routes.REGISTER)}>
        <span> Đăng ký tham gia</span>
      </div>
      <MobileWhyChoice />
      <MobileStartNow />
      <MobilePartner />
    </div>
  );
};

export default MobileHome;
